import React from 'react';

import { Button, ButtonProps, Image } from '@mantine/core';
import logoDark from 'assets/images/logo_dark.png';
import logoLight from 'assets/images/logo_light.png';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTE_LINKS } from 'shared/constants/route-links';

interface UpgradePlanButtonProps extends ButtonProps {
  showLogo?: boolean;
  label?: string;
  dark?: boolean;
}

export function UpgradePlanButton({ showLogo = false, label, dark = false, ...buttonProps }: UpgradePlanButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      size="xs"
      leftIcon={showLogo ? <Image width={15} src={dark ? logoDark : logoLight} /> : undefined}
      sx={{
        opacity: '1 !important',
        backgroundColor: buttonProps.variant === 'filled' ? 'black !important' : undefined
      }}
      onClick={() => navigate(`${ROUTE_LINKS.billing}`)}
      {...buttonProps}>
      {label || t('APP.ACTIONS.UPGRADE_PLAN')}
    </Button>
  );
}
